
/**
 * Utility functions for handling retries and delays
 */

/**
 * Creates a delay using a promise
 */
export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Retries a function with exponential backoff, particularly useful for rate-limited API calls
 */
export const retryWithBackoff = async (fn: () => Promise<any>, maxRetries = 8, initialDelay = 10000) => {
  let retries = 0;
  while (retries < maxRetries) {
    try {
      return await fn();
    } catch (error: any) {
      if (error?.message?.includes('rate limit') && retries < maxRetries - 1) {
        const waitTime = initialDelay * Math.pow(3, retries);
        console.log(`Rate limit hit, retrying in ${waitTime}ms... (Attempt ${retries + 1}/${maxRetries})`);
        await delay(waitTime);
        retries++;
      } else {
        throw error;
      }
    }
  }
};
